(() => {
  'use strict';
  if (window.EvolvedCategoryVideo) return;
  window.EvolvedCategoryVideo = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  function mount(video) {
    if (initialized.has(video)) return;
    const source = video.querySelector('source[data-src]');
    const card = video.closest('.eclb-card');
    if (!source || !card || !('IntersectionObserver' in window)) return;
    initialized.add(video);
    const controller = new AbortController();
    const {signal} = controller;
    let visible = false, loading = false;
    video.muted = true; video.defaultMuted = true;
    const allowed = () => visible && !document.hidden && !reduce.matches && !navigator.connection?.saveData;
    const stop = () => { video.pause(); delete video.dataset.playing; };
    const update = async () => {
      if (!allowed()) { stop(); return; }
      if (loading) return;
      loading = true;
      try {
        if (!source.src) { source.src = source.dataset.src; video.load(); }
        await video.play();
        if (!allowed()) stop();
        else video.dataset.playing = 'true';
      } catch (_) { stop(); }
      finally { loading = false; }
    };
    video.addEventListener('playing', () => { if (allowed()) video.dataset.playing = 'true'; else stop(); }, {signal});
    video.addEventListener('error', stop, {signal});
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        visible = entry.isIntersecting && entry.intersectionRatio >= .1;
        update();
      }
    }, {threshold:[0,.1]});
    observer.observe(card);
    document.addEventListener('visibilitychange', update, {signal});
    reduce.addEventListener('change', update, {signal});
    navigator.connection?.addEventListener?.('change', update, {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(video)) return;
      stop(); observer.disconnect(); controller.abort();
    }, {signal});
  }
  const scan = root => root.querySelectorAll('[data-ev-category-video]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
